<template>
  <div>
    <div class="px-4 pb-3">
      <v-btn style="float: right" icon @click="$emit('close')">
        <v-icon>close</v-icon>
      </v-btn>

      <div style="font-size: 20px; font-weight: 600" class="pt-3 mb-3">
        {{ edittype == 'create' ? 'เพิ่ม' : 'แก้ไข' }}ข้อมูล IMEI
      </div>
      <div class="form-control">
        <v-layout class="pa-0 ma-0" wrap row
          ><v-flex xs12 sm6 class="form-control pa-1" :class="{ 'has-error': errors.has('Imei') }">
            <label>{{ $t('Imei') }}</label>
            <input
              v-model="input.imei"
              v-validate="'required'"
              :data-vv-as="$t('Imei')"
              :disabled="edittype == 'edit'"
              class="form-control"
              type="text"
              name="Imei"
            />
            <span v-if="errors.has('Imei')" class="text-error">{{ errors.first('Imei') }}</span>
          </v-flex>
          <v-flex
            xs12
            sm6
            class="form-control pa-1"
            :class="{ 'has-error': errors.has('เครื่องที่ได้รับ') }"
          >
            <label>{{ $t('เครื่องที่ได้รับ') }}</label>
            <input
              v-model="input.points"
              v-validate="'required'"
              :data-vv-as="$t('เครื่องที่ได้รับ')"
              class="form-control"
              type="number"
              name="เครื่องที่ได้รับ"
            />
            <span v-if="errors.has('เครื่องที่ได้รับ')" class="text-error">{{
              errors.first('เครื่องที่ได้รับ')
            }}</span>
          </v-flex>
          <v-flex
            xs12
            sm12
            class="form-control pa-1"
            :class="{ 'has-error': errors.has('ข้อมูลเครื่อง') }"
          >
            <label>{{ $t('ข้อมูลเครื่อง') }}</label>
            <input
              v-model="input.description"
              v-validate="'required'"
              :data-vv-as="$t('ข้อมูลเครื่อง')"
              class="form-control"
              type="text"
              name="ข้อมูลเครื่อง"
            />
            <span v-if="errors.has('ข้อมูลเครื่อง')" class="text-error">{{
              errors.first('ข้อมูลเครื่อง')
            }}</span>
          </v-flex>
        </v-layout>
        <div class="text-xs-center">
          <v-btn outline color="grey" @click="$emit('close')">cancel</v-btn>
          <v-btn :loading="saveloading" depressed color="primary" @click="savedata">save</v-btn>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/api'
import { mapGetters } from 'vuex'
export default {
  props: ['edittype', 'editdata'],
  data() {
    return {
      saveloading: false,
      input: {
        imei: '',
        description: '',
        points: ''
      }
    }
  },
  computed: {
    ...mapGetters(['selectedBot'])
  },
  mounted() {
    if (this.edittype == 'edit') {
      this.input = { ...this.editdata }
    }
  },
  methods: {
    async savedata() {
      if (await this.$validator.validateAll()) {
        if (this.edittype == 'create') {
          this.createdata()
        } else {
          this.editbranch()
        }
      }
    },
    editbranch() {
      var data = { pageid: this.selectedBot.pageid, ...this.input }
      this.saveloading = true
      api.updateYasaleImei(data, (err, response) => {
        this.saveloading = false
        if (response.responsecode == 200) {
          this.$emit('onsave')
        }
      })
    },
    createdata() {
      var data = { pageid: this.selectedBot.pageid, ...this.input }
      this.saveloading = true
      api.createYasaleImei(data, (err, response) => {
        this.saveloading = false
        if (response.responsecode == 200) {
          this.$emit('onsave')
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/yasale/imei/ImeiEdit.vue